// @flow

import * as React from 'react';
import invariant from 'invariant';
import hoistStatics from 'hoist-non-react-statics';
import type { WorkflowManager } from 'esm-web-pro/workflows';
import Context from './context';


function connectWorkflow <Config: {}>(
    Wrapped: React.AbstractComponent<Config>,
): React.AbstractComponent<$Diff<Config, {
    startFlow: (code: string, data: Object, actionHandlers?: {
        [string]: {
            async: boolean,
            func: (data: { executionId: string, [string]: any }, context: Object) => any,
        },
    }) => Promise<Object>,
    resumeFlow: (executionId: string, data: Object) => Promise<Object>
}>> {
    const wrappedComponentName = Wrapped.displayName || Wrapped.name || 'Component';
    const displayName = `ConnectWorkflow(${wrappedComponentName})`;

    class ConnectWorkflow extends React.PureComponent<Object, Object> {
        renderWrapped = (value: { workflowManager: WorkflowManager }) => {
            invariant(
                value,
                `Could not find "workflowManager" in the context of "${displayName}". 
Either wrap the root component in a <WorkflowProvider>, 
or pass a custom React context provider to <WorkflowProvider> and the corresponding 
React context consumer to ${displayName} in connect options.`,
            );
            const { workflowManager } = value;

            return (
                <Wrapped
                    {...this.props}
                    startFlow={workflowManager.startFlow}
                    resumeFlow={workflowManager.resumeFlow}
                />
            );
        };

        render() {
            return (
                <Context.Consumer>
                    {this.renderWrapped}
                </Context.Consumer>
            );
        }
    }

    return hoistStatics(ConnectWorkflow, Wrapped);
}

export default connectWorkflow;
